import "./Benefits.css";
import careerBenefits from "../../../Assets/Images/career-benefits.svg";

import benefitsIcon1 from "../../../Assets/Icons/benefits-icon1.svg";
import benefitsIcon2 from "../../../Assets/Icons/benefits-icon2.svg";
import benefitsIcon3 from "../../../Assets/Icons/benefits-icon3.svg";
import benefitsIcon4 from "../../../Assets/Icons/benefits-icon4.svg";
import benefitsIcon5 from "../../../Assets/Icons/benefits-icon5.svg";
import benefitsIcon6 from "../../../Assets/Icons/benefits-icon6.svg";
import benefitsIcon7 from "../../../Assets/Icons/benefits-icon7.svg";
import benefitsIcon8 from "../../../Assets/Icons/benefits-icon8.svg";

const Benefits = () => {
  const benefits = [
    {
      title: "An Environment That Pushes You Forward",
      description:
        "You will be working on real systems - not toy problems. Curiosity is encouraged, questions are welcomed and new ideas are tested in actual projects, not left in documents.",
      icon: benefitsIcon1,
    },
    {
      title: "Room To Grow, Not Just Perform",
      description:
        "Growth here is practical. You learn by building things, reviewing, breaking things, improving things in real products with help from people who care about doing things right.",
      icon: benefitsIcon2,
    },
    {
      title: "Collaboration Without Ego",
      description:
        "You will collaborate with people that have the same context, provide honest feedback, and complete problems together rather than competing for credit.",
      icon: benefitsIcon3,
    },
    {
      title: "Work That Actually Matters",
      description:
        "Projects here are not filler. You are part of platforms and systems that real businesses and users relied on daily.",
      icon: benefitsIcon4,
    },
    {
      title: "Balance That Respects Real Life",
      description:
        "Good work requires rest and concentration. We encourage flexible work and remote work so that people are able to work well without burning out.",
      icon: benefitsIcon5,
    },
    {
      title: "Effort That Gets Noticed",
      description:
        "Good thinking and sound execution don't fade away quietly. We make a point to recognise contributions to improving the team and the work.",
      icon: benefitsIcon6,
    },
    {
      title: "Constant Skill Sharpening",
      description:
        "Different projects have different challenges. Over time, your skills become deeper simply by working in a variety of technologies, domains, and types of problems.",
      icon: benefitsIcon7,
    },
    {
      title: "A Clear Path To Leadership",
      description:
        "Leadership here is enhanced by trust and competence. If you take ownership and are consistent, opportunities to lead follow naturally.",
      icon: benefitsIcon8,
    },
  ];

  return (
    <div className="benefits-container">
      <div className="benefits-content-wrapper">
        <div className="section-title-wrapper">
          <h2 className="section-title">Why People Choose To Build Their Careers Here</h2>
        </div>

        <div className="content-wrapper">
          <div className="image-section">
            <img
              src={careerBenefits}
              alt="Culture - Variety and Difference"
              className="culture-image"
            />
          </div>

          <div className="benefits-list">
            {benefits.map((item, index) => (
              <div key={index} className="benefit-item">
                <div className="benefit-icon-wrapper">
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="benefit-icon"
                  />
                </div>
                <div className="benefit-content">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
